const isProduction = process.env.NODE_ENV === 'production'
const bases = {
  // /*生产*/
  api: 'https://www.huodaipin.com',
  // /*灰度*/
  uat: 'https://www.huodaipin.com.cn/',
  // uat: 'http://oms.test.uat.huodaipin.com.cn/',
  // /* 测试环境 */
  // admin:'http://8.134.131.100:8900/',
  // test:'https://qa2.huodaipin.com.cn/',
  test:'http://oms.dev.huodaipin.com.cn/',
  /*其他同事*/
  eli: 'http://192.168.1.160:9001',

  // asong: '',
  // one: 'http://192.168.1.29:8080/',
  // joy: 'http://192.168.1.169:8080',
  // peter: 'http://192.168.1.17:8082/',
  // eleven: 'http://192.168.1.236:8080/',
  // scorpio:"http://192.168.1.230:8058/",//吴谦
  // pengWu:"http://192.168.1.162:8081/",//彭武
  // harry:"http://192.168.1.120:8081/",//
  // daxin: "http://192.168.1.178:80/", // 大欣
  // hanson: "http://192.168.1.114:80/", // hanson
  // dev:  "http://192.168.1.240:8073/" // 亦邦开发环境
  // Hanson
  jing: "http://192.168.1.221:8081/",
  patton: "http://1.13.171.173:7008/",
  hanson: "http://192.168.1.131:8080/",
  plan: "http://192.168.1.244:8080/",
};
// 开发地址，仅开发环境有效
// let proxyTarget = bases.test;
let proxyTarget = bases.uat;
let openProxy = true;

let thanProxy = {
  target: proxyTarget,
  changeOrigin: true,
  secure: false
};
let proxyConfig ={
  '/api': thanProxy,
  '/cms': thanProxy,
  "/ies": thanProxy,
};
const ossPath = "https://huodaipin-test.oss-cn-hongkong.aliyuncs.com/web/v1.0.0";

let _qrCodeOrigin = {
  // 正式
  main:{
    gzh: ossPath + "/pages/qrCode/main/wx_ems_cnpl.jpg",
    applet: ossPath + "/pages/qrCode/main/wx_applet.jpg",
    wxService: ossPath + "/pages/qrCode/main/wx_service.png",
    serviceUrl: 'https://work.weixin.qq.com/kfid/kfca0011ccf7f9ea49f'
  },
  // uat
  uat:{
    gzh: ossPath + "/pages/qrCode/uat/wx_ems_cnpl.jpg",
    applet: ossPath + "/pages/qrCode/uat/wx_applet.jpg",
    wxService: ossPath + "/pages/qrCode/uat/wx_service.png",
    serviceUrl: 'https://work.weixin.qq.com/kfid/kfcfb7353f2df77887d'
  },
  // qa1
  qa1:{
    gzh: ossPath + "/pages/qrCode/qa1/wx_ems_cnpl.jpg",
    applet: ossPath + "/pages/qrCode/qa1/wx_applet.jpg",
    wxService: ossPath + "/pages/qrCode/qa1/wx_service.png",
  },
  // qa2
  qa2:{
    gzh: ossPath + "/pages/qrCode/qa1/wx_ems_cnpl.jpg",
    applet: ossPath + "/pages/qrCode/qa1/wx_applet.jpg",
    wxService: ossPath + "/pages/qrCode/qa1/wx_service.png",
    serviceUrl: 'https://work.weixin.qq.com/kfid/kfc938c57163c6f70bf'
  },
}

let qrCodeImages = _qrCodeOrigin.main;
if(isProduction){
  if(typeof location !== "undefined" && location.hostname){
    let isQa1 = ["qa1.huodaipin.com.cn"].includes(location.hostname);
    let isQa2 = ["qa2.huodaipin.com.cn"].includes(location.hostname);
    let isUat = ["www.huodaipin.com.cn"].includes(location.hostname);
    console.log("isUat = ",isUat,"isQa1 = ",isQa1);
    if(isQa1) qrCodeImages = _qrCodeOrigin.qa1;
    if(isQa2) qrCodeImages = _qrCodeOrigin.qa2;
    else if(isUat) qrCodeImages = _qrCodeOrigin.uat;
  }
}else{
  qrCodeImages = _qrCodeOrigin.qa2;
}


module.exports = {proxyTarget,proxyConfig,openProxy,isProduction,qrCodeImages, ossPath};



//////////////////
// WEBPACK FOOTER
// ./devParams.js
// module id = Fone
// module chunks = 36